/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.estadosDetalles': 'Estados  Detalles',
'estadosDetalles.agregarEstados Detalles': 'Create Estados  Detalles',
'estadosDetalles.modificarEstados Detalles': 'Edit Estados  Detalles',
'estadosDetalles.eliminarEstados Detalles': 'Delete Estados  Detalles',
'estadosDetalles.estadoDetalleId': 'Estado   Detalle   Id ',
'estadosDetalles.empresaId': ' Empresa   Id ',
'estadosDetalles.descripcionEstadoDetalle': ' Descripcion   Estado   Detalle',
'estadosDetalles.estados Detalles': 'Estados  Detalles',
'estadosDetalles.verEstados Detalles': 'View Estados  Detalles',
};

